export default __webpack_public_path__ + "static/media/phones-md.58fc7ce8.png";